import { render } from "./EditChampionsForm.vue?vue&type=template&id=38dcb7b6&scoped=true"
import script from "./EditChampionsForm.vue?vue&type=script&lang=js"
export * from "./EditChampionsForm.vue?vue&type=script&lang=js"

import "./EditChampionsForm.vue?vue&type=style&index=0&id=38dcb7b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38dcb7b6"]])

export default __exports__